import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { Globals } from '../../globals';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { LoadingController } from 'ionic-angular';
import { HttpParams, HttpClient } from '@angular/common/http';
import { TakeawayServices } from '../takeaway/services';
import { AnalyticsServices } from '../services/analyticsServices';
import { ArticlesServices } from '../articles/services';
import { CustomersServices } from '../customers/services';
import { ConfigurationServices } from '../configuration/services';

interface Table {
  UID: string;
  key: string;
  name: string;
  ticket: any;
  cash_static: any;
  cash_uid: any;
  type: string;
  discount_type: string;
  discount_value: number;
  datetime_pickup_delivey: any;
  show_takeaway: boolean;
}

interface Order {
  UID: string;
  UID_RESTAURANT: string;
  hour: string;
  sections: any;
  show_kitchen: boolean;
  table: string;
  type: string;
  waiter: string;
  waiter_uid: string;
}

// Definición de constantes para índices de estado
const STATE_ALL_INDEX = 0;
const STATE_PAYMENT_COMPLETED_INDEX = 4;
const STATE_PENDING_INDEX = 2;

@Injectable()
export class OdsServices {

  public firestore: any;
  public select_date1: any = new Date().setHours(0, 0, 0);
  public select_date2: any = new Date().setHours(23, 59, 59);
  public show_deliveries: boolean = true;
  public show_takeaways: boolean = true;
  public filter_by_state: string = 'stateless';
  public total_amount: number = 0;
  public states = [
    {
      'name': this.translate.instant('general-todos'),
      'name_indv': this.translate.instant('general-todos'),
      'active': false,
      'required': true,
      'state': 'all', //todos
      'total_orders': 0
    },
    {
      'name': this.translate.instant('tk-state-stateless'),
      'name_indv': this.translate.instant('tk-state-stateless'),
      'active': false,
      'required': false,
      'state': 'stateless', //sin_estado
      'total_orders': 0
    },
    {
      'name': this.translate.instant('general-pendientes'),
      'name_indv': this.translate.instant('general-pendiente'),
      'active': false,
      'required': true,
      'state': 'received', //recibida
      'total_orders': 0
    },
    {
      'name': this.translate.instant('tk-state-accepted'),
      'name_indv': this.translate.instant('tk-state-accepted'),
      'active': false,
      'required': true,
      'state': 'accepted', //aceptada
      'total_orders': 0
    },
    {
      'name': this.translate.instant('tk-state-payment-completed'),
      'name_indv': this.translate.instant('tk-state-payment-completed'),
      'active': false,
      'required': false,
      'state': 'payment_completed', //pago_completado
      'total_orders': 0
    },
    {
      'name': this.translate.instant('general-en-preparacion'),
      'name_indv': this.translate.instant('general-en-preparacion'),
      'active': false,
      'required': false,
      'state': 'kitchen', //cocina
      'total_orders': 0
    },
    {
      'name': this.translate.instant('tk-state-ready-for-pickup'),
      'name_indv': this.translate.instant('tk-state-ready-for-pickup'),
      'active': false,
      'required': false,
      'state': 'ready_for_pickup', //lista_para_el_rider
      'total_orders': 0
    },
    {
      'name': this.translate.instant('tk-state-prepared'),
      'name_indv': this.translate.instant('tk-state-prepared'),
      'active': false,
      'required': false,
      'state': 'prepared', //preparada
      'total_orders': 0
    },
    {
      'name': this.translate.instant('tk-state-sent'),
      'name_indv': this.translate.instant('tk-state-sent'),
      'active': false,
      'required': false,
      'state': 'sent', //enviada
      'total_orders': 0
    },
    {
      'name': this.translate.instant('tk-state-delayed-15'),
      'name_indv': this.translate.instant('tk-state-delayed-15'),
      'active': false,
      'required': false,
      'state': 'delayed_15', //en retraso
      'total_orders': 0
    },
    {
      'name': this.translate.instant('tk-state-delayed-30'),
      'name_indv': this.translate.instant('tk-state-delayed-30'),
      'active': false,
      'required': false,
      'state': 'delayed_30', //en retraso
      'total_orders': 0
    },
    {
      'name': this.translate.instant('general-finalizados'),
      'name_indv': this.translate.instant('general-finalizado'),
      'active': false,
      'required': false,
      'state': 'completed', //completada
      'total_orders': 0
    },
    {
      'name': this.translate.instant('tk-state-cancelled'),
      'name_indv': this.translate.instant('tk-state-cancelled'),
      'active': false,
      'required': true,
      'state': 'cancelled', //cancelada
      'total_orders': 0
    },
    {
      'name': this.translate.instant('tk-state-failed'),
      'name_indv': this.translate.instant('tk-state-failed'),
      'active': false,
      'required': false,
      'state': 'failed', //fallada
      'total_orders': 0
    }
  ];
  public selected_elements: any = [];
  public show_alerts_config: boolean = false;
  public show_alert_info_starter: boolean = false;
  public show_config_tab: boolean = false;
  public loader_analytics: boolean = false;

  constructor(public afs: AngularFirestore,
    public globals: Globals,
    public translate: TranslateService,
    public loadingCtrl: LoadingController,
    public http: HttpClient,
    public takeawayServices: TakeawayServices,
    public analyticsServices: AnalyticsServices,
    public articlesServices: ArticlesServices,
    public customersServices: CustomersServices,
    public configurationServices: ConfigurationServices) {
    this.firestore = firebase.firestore();
  }

  takeaway_config: any = {};
  async getTakeawayConfig() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-loading')
    });
    if (!this.takeaway_config.states_active) {
      loadingPopup.present();
    }
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid);

    const response = await this.http.post(this.globals.analytics_path + 'takeaway/config', params, {}).toPromise();

    if (!response || !response['config']) {
      //check old if activated
      var config_payments = false;
      if (this.globals.restaurant.payment_method_stripe || this.globals.restaurant.payment_method_paypal || this.globals.restaurant.payment_method_redsys || this.globals.restaurant.payment_method_redsys_bizum) {
        config_payments = true;
      }
      //update in firestore
      this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/takeaway').doc('config').set({
        config_horary: false,
        config_shipment: false,
        config_menu: false,
        config_payments: config_payments,
        config_customize: false,
        states_active: ['all', 'stateless', 'received', 'accepted', 'completed', 'cancelled']
      });
      this.takeaway_config = {
        config_horary: false,
        config_shipment: false,
        config_menu: false,
        config_payments: config_payments,
        config_customize: false,
        states_active: ['all', 'stateless', 'received', 'accepted', 'completed', 'cancelled']
      };
      //activar states igual a config de takeaway
      this.activeSates();
      //
      this.show_alerts_config = true;
    } else {
      this.takeaway_config = response['config'];
      if (this.takeaway_config.states_active === undefined) {
        this.takeaway_config.states_active = ['all', 'stateless', 'received', 'accepted', 'completed', 'cancelled'];
      }
      //Comprovamos si el usuario ha configurado todo del apartado pedidos
      this.show_alerts_config = Object.keys(this.takeaway_config)
        .filter(key => key.startsWith('config'))
        .some(key => this.takeaway_config[key] === false);
      if (this.show_alerts_config === false && (this.globals.restaurant.plg_pedidos_finisher === undefined || this.globals.restaurant.plg_pedidos_finisher === false)) {
        this.globals.restaurant.plg_pedidos_finisher = true;
        //save plg_pedidos_finisher
        this.globals.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
          plg_pedidos_finisher: true
        });
        //send trackingExpPedidos
        this.analyticsServices.trackingExpPedidos('finisher', this.globals.tracking_exp['finisher']);
      }
      //activar states igual a config de takeaway
      this.activeSates();
    }
    loadingPopup.dismiss();
  }

  activeSates() {
    this.takeaway_config.states_active.forEach(state => {
      let index = this.states.findIndex(x => x.state === state);
      if (index != -1) {
        if (state === 'all') {
          this.filter_by_state = 'all';
        }
        this.states[index].active = true;
      }
    });
  }

  tablesDoc: AngularFirestoreCollection<Table>;
  tablesChanges: any;
  tablesList: any = [];
  tablesListFiltered: any = [];
  getTables() {
    //Desuscribirse de la suscripción anterior si existe
    if (this.tablesChanges) {
      this.tablesChanges.unsubscribe();
    }
    this.tablesDoc = this.afs.collection('tables', ref => ref.where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
      .where('type', '==', 'takeaway')
      .where('datetime_pickup_delivey', '>=', moment(this.select_date1).startOf('day').toDate())
      .where('datetime_pickup_delivey', '<=', moment(this.select_date2).endOf('day').toDate())
      .orderBy('datetime_pickup_delivey', "desc"));
    this.tablesChanges = this.tablesDoc.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Table;
        data.UID = a.payload.doc.id;
        data.key = this.globals.generateOrderCode(data.UID);
        return data;
      })
    }).subscribe(value => {
      this.tablesList = value.filter(x => x.show_takeaway == true || x.show_takeaway == undefined);
      this.takeawayServices.tables_array = this.tablesList;
      this.filterTables();
    });
  }

  filterTables() {
    this.total_amount = 0;
    //Reseteamos el total de orders de los estados
    this.states.forEach(x => x.total_orders = 0);
    //Filtrar por estados y tipo delivery (Recogida/Takeaway)
    this.tablesListFiltered = this.tablesList.filter(table => {
      //Takeaways
      if (this.show_takeaways && table.ticket.delivery === "Recogida") {
        // Sumamos el amount y una order al estado "all"
        this.total_amount += this.takeawayServices.totalTicketSelectedTable(table);
        this.states[STATE_ALL_INDEX].total_orders++;

        // Actualizamos el estado correspondiente
        let index = this.states.findIndex(x => x.state === table.order_state);
        if (index !== -1) {
          this.states[index].total_orders++;
        }

        // Verificación de pago completado
        if (table.order_state === 'payment_completed' && !this.states[STATE_PAYMENT_COMPLETED_INDEX].active) {
          this.states[STATE_PENDING_INDEX].total_orders++;
        }

        // Filtrado por estado
        return this.filter_by_state === 'all' || table.order_state === this.filter_by_state ||
          (table.order_state === 'payment_completed' && !this.states[STATE_PAYMENT_COMPLETED_INDEX].active &&
            (this.filter_by_state === 'received' || this.filter_by_state === 'payment_completed'));
      }
      //Deliveries
      if (this.show_deliveries && table.ticket.delivery !== "Recogida") {
        // Sumamos el amount y una order al estado "all"
        this.total_amount += this.takeawayServices.totalTicketSelectedTable(table);
        this.states[STATE_ALL_INDEX].total_orders++;

        // Actualizamos el estado correspondiente
        let index = this.states.findIndex(x => x.state === table.order_state);
        if (index !== -1) {
          this.states[index].total_orders++;
        }

        // Verificación de pago completado
        if (table.order_state === 'payment_completed' && !this.states[STATE_PAYMENT_COMPLETED_INDEX].active) {
          this.states[STATE_PENDING_INDEX].total_orders++;
        }

        // Filtrado por estado
        return this.filter_by_state === 'all' || table.order_state === this.filter_by_state ||
          (table.order_state === 'payment_completed' && !this.states[STATE_PAYMENT_COMPLETED_INDEX].active &&
            (this.filter_by_state === 'received' || this.filter_by_state === 'payment_completed'));
      }
      return false;
    });
  }

  ordersDoc: AngularFirestoreCollection<Order>;
  ordersChanges: any;
  ordersList: any = [];
  ordersListFiltered: any = [];
  restaurantChanges: any;
  
  getOrders() {
    //Desuscribirse de la suscripción anterior si existe
    if (this.ordersChanges) {
      this.ordersChanges.unsubscribe();
    }
    this.ordersDoc = this.afs.collection('orders', ref => ref.where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
      .where('type', '==', 'takeaway')
      .where('show_order', '==', true)
      .where('datetime_pickup_delivey', '>=', moment(this.select_date1).startOf('day').toDate())
      .where('datetime_pickup_delivey', '<=', moment(this.select_date2).endOf('day').toDate())
      .orderBy('datetime_pickup_delivey', "desc"));
    this.ordersChanges = this.ordersDoc.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Order;
        data.UID = a.payload.doc.id;
        return data;
      });
    }).subscribe(value => {
      this.ordersList = value;
    });
  }

  carta_takeaway: any = {};
  carta_takeaway_listener: any; // Listener para sincronización en tiempo real
  
  getCartaTakeaway(forceReload: boolean = false) {
    // Solo recargar si no hay carta cargada o si se fuerza la recarga
    if (!this.carta_takeaway.UID || forceReload) {
      //hacer peticion a endpoint como con getTakeawayConfig
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid);
      return this.http.post(this.globals.analytics_path + 'takeaway/get_carta', params, {}).toPromise().then(response => {
        this.carta_takeaway = response;

        //Si no ha configurado la carta tk, pero ya tenia una hecha, guardamos como que ya tiene la carta configurada
        if (!this.takeaway_config.config_menu) {
          this.takeaway_config.config_menu = true;
          this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/takeaway').doc('config').update(this.takeaway_config);
        }
        return response;
      });
    } else {
      // Retorna la carta ya cargada
      return Promise.resolve(this.carta_takeaway);
    }
  }

  // Método para forzar la recarga de la carta cuando sea necesario
  reloadCartaTakeaway() {
    return this.getCartaTakeaway(true);
  }


  startCartaTakeawayListener() {
    if (this.carta_takeaway_listener) return;
    
    if (!this.carta_takeaway || !this.carta_takeaway.UID) {
      return;
    }

    this.carta_takeaway_listener = this.firestore
      .collection('cartas')
      .doc(this.carta_takeaway.UID)
      .onSnapshot((doc) => {
        if (doc.exists) {
          const data = doc.data();
          data.UID = doc.id;
          this.carta_takeaway = data;
        }
      }, (error) => {
        console.error('Error en listener de carta:', error);
      });
  }

  subscribeToRestaurantChanges() {
    // Desuscribirse de la suscripción anterior si existe
    if (this.restaurantChanges) {
      this.restaurantChanges();
    }
    
    this.restaurantChanges = this.firestore.collection('restaurants')
      .doc(this.globals.restaurant_uid)
      .onSnapshot((doc) => {
        if (doc.exists) {
          const data = doc.data();
          // Actualizar el estado de pedidos online en tiempo real
          if (data.web_tk_active !== undefined) {
            this.globals.restaurant.web_tk_active = data.web_tk_active;
          }
        }
      });
  }

  stopCartaTakeawayListener() {
    if (this.carta_takeaway_listener) {
      this.carta_takeaway_listener();
      this.carta_takeaway_listener = null;
    }
  }

  zip_codes: any = [];
  zip_code_show: string = '';
  getCP() {
    this.zip_codes = [];
    this.zip_code_show = '';
    this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/zip_codes').get().then(snapshot => {
      snapshot.forEach(doc => {
        const zip_code = doc.data();
        zip_code.UID = doc.id;
        this.zip_codes.push(zip_code);
        this.zip_code_show += zip_code.code + ',';
      })
    });
  }

  get_elements_done: boolean = false;
  list_elements: any = [];
  list_elements_filtered: any = [];
  async getElements(elements_per_page) {
    this.get_elements_done = false;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('elements_per_page', elements_per_page);
    await this.http.post(this.globals.analytics_path + 'paginate/dishes_products_combos', params, {})
      .subscribe(async res => {
        this.list_elements = res['list'];
        if (this.list_elements.length != 0) {
          this.listElementsOrder();
        }
      });
  }

  listElementsOrder() {
    this.get_elements_done = true;
    //Ordenamos el array
    this.list_elements.sort((a, b) => this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b)));
    this.list_elements_filtered = this.list_elements;
  }

  sales_delivery: number = 0;
  total_sales: number = 0;
  visits: number = 0;
  carts: number = 0;

  async getTakeawayAnalytics() {
    this.loader_analytics = false;
    try {
      const params = new HttpParams()
        .set('public_key', this.globals.public_key)
        .set('first_date', moment(this.select_date1).startOf('day').format('YYYY-MM-DD HH:mm:ss'))
        .set('last_date', moment(this.select_date2).endOf('day').format('YYYY-MM-DD HH:mm:ss'));
      this.http.post(this.globals.analytics_path + 'analytics/delivery_ods', params, {})
        .subscribe(async response => {
          this.sales_delivery = response['sales'];
          this.total_sales = response['total_sales'];
          this.visits = response['visits'];
          this.carts = response['carts'];
          this.loader_analytics = true;
        });
    } catch (error) {
      this.loader_analytics = true;
    }
  }

  formatState(status) {
    switch (status) {
      case 'stateless': {
        return this.translate.instant('tk-state-stateless');
      }
      case 'received': {
        return this.translate.instant('general-pendiente');
      }
      case 'accepted': {
        return this.translate.instant('tk-state-accepted');
      }
      case 'payment_completed': {
        return this.translate.instant('tk-state-payment-completed');
      }
      case 'kitchen': {
        return this.translate.instant('general-en-preparacion');
      }
      case 'ready_for_pickup': {
        return this.translate.instant('tk-state-ready-for-pickup');
      }
      case 'prepared': {
        return this.translate.instant('tk-state-prepared');
      }
      case 'sent': {
        return this.translate.instant('tk-state-sent');
      }
      case 'delayed_15': {
        return this.translate.instant('tk-state-delayed-15');
      }
      case 'delayed_30': {
        return this.translate.instant('tk-state-delayed-30');
      }
      case 'completed': {
        return this.translate.instant('general-finalizado');
      }
      case 'cancelled': {
        return this.translate.instant('tk-state-cancelled');
      }
      case 'failed': {
        return this.translate.instant('tk-state-failed');
      }
      default: {
        return this.translate.instant('tk-state-stateless');
      }
    }
  }

  async createExamplesPlgTakeaway() {
    //get articles
    var _articles = await this.articlesServices.getAllArticles();
    var articles = _articles['list'];
    //get customers (create new if no)
    var customers = await this.customersServices.getCustomers(this.globals.restaurant_uid);
    //create customer
    if (customers.length === 0) {
      var customer = await this.createAndReturnCustomer();
      customers.push(customer);
    }
    //get cash
    var cashs = await this.configurationServices.getCashFirst(this.globals.restaurant_uid);
    var _cash = cashs[0]; //Por defecto ponemos la primera caja
    //Recuperamos la caja activa
    if (!this.globals.checkLimitsByLicense('config', 'multi_cash')) {//Si tiene limite de cajas, cogemos una caja activa
      cashs.forEach(cash => {
        if (cash._active) {
          _cash = cash;
        }
      });
    } else { //Si no tiene limite de cajas, cogemos la primera caja recuperada
      _cash = cashs[0];
    }
    //prepare tables takeaway
    if (articles.length > 0 && customers.length > 0) {
      var tk_base = {
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'cash_static': _cash.name,
        'cash_uid': _cash.UID,
        'name': '',
        'persons': '',
        'size': 2,
        'state': 'open',
        'ticket': {
          'amount': 0,
          'number': '',
          'payment': false,
          'payment_type': '',
          'list': [{
            'name': this.globals.nameLangSelectDish(articles[0]),
            'price': articles[0].price,
            'delete': false,
            'count': true,
            'type': articles[0].type,
            'uid_element': articles[0].UID,
            'variation': [],
            'waiter': this.globals.waiter,
            'waiter_uid': this.globals.waiter_uid,
            'tags': articles[0].tags,
          }],
          'date': new Date(),
          'waiter_uid': this.globals.waiter_uid,
          'waiter': this.globals.waiter,
          'delivery': 'Domicilio',
          'created_at': new Date(),
          'updated_at': new Date(),
          'order_state': 'stateless',
          'tip': 0
        },
        'type': 'takeaway',
        'uid_room': '',
        'customer_name': customers[0].name,
        'customer_address': customers[0].address,
        'customer_phone': customers[0].phone,
        'customer_email': customers[0].email,
        'customer_uid': customers[0].UID,
        'created_at': new Date(),
        'updated_at': new Date(),
        'notes': customers[0].note,
        'datetime_pickup_delivey': new Date(),
        'order_state': 'stateless',
      }
      //add to firestore
      await this.createTakeaway(tk_base, customers[0]);
      //add to firestore
      tk_base.ticket.delivery = 'Recogida'
      tk_base.ticket.order_state = 'received';
      tk_base.order_state = 'received';
      await this.createTakeaway(tk_base, customers[0]);
      //add to firestore
      tk_base.ticket.delivery = 'Recogida'
      tk_base.ticket.order_state = 'accepted';
      tk_base.order_state = 'accepted';
      await this.createTakeaway(tk_base, customers[0]);
    }
  }

  async createTakeaway(tk_object, _customer) {
    await this.takeawayServices.afs.collection('tables').add(tk_object).then(async doc => {
      //create order
      var today = new Date();
      var _order_tmp = [];
      //insert to orders
      _order_tmp = [];

      var _elements_list = [];

      var _combo_section = true;
      var _list = [];
      for (let list of this.globals.objectToArray(tk_object.ticket.list)) {
        var obj = {};
        if (list.uid_combo_tmp != undefined) {
          obj = {
            name: list.name,
            change: '',
            finish: '',
            state: 'normal',
            variations: list.variation,
            uid_combo_tmp: list.uid_combo_tmp,
            uid_element_combo: list.uid_element_combo,
            tags: list.tags,
            uid_element: list.uid_element
          }

          if (list.type == 'combo') {
            _combo_section = false;
          }
        } else {
          obj = {
            name: list.name,
            change: '',
            finish: '',
            state: 'normal',
            variations: list.variation,
            tags: list.tags,
            uid_element: list.uid_element
          }
          _combo_section = false;
        }
        _list.push(obj);
        //guardamos el elemento para insertarlo en la analytics WAITER
        _elements_list.push(list.name);
      }
      var _oder = {
        name: 'Todos',
        list: _list,
        only_combo: _combo_section,
      }
      _order_tmp.push(_oder);

      var order = {
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'date': today,
        'hour': moment(today).format("HH:mm"),
        'sections': _order_tmp,
        'show_kitchen': true,
        'show_order': true,
        'table': '',
        'table_uid': doc.id,
        'type': 'takeaway',
        'waiter': this.globals.waiter,
        'waiter_uid': this.globals.waiter_uid,
        'created_at': new Date(),
        'updated_at': new Date(),
        'provider': 'General',
        'provider_code': '',
        'delivery': tk_object.ticket.delivery,
        'notes': tk_object.notes,
        'datetime_pickup_delivey': tk_object.datetime_pickup_delivey,
        'customer': _customer,
      };
      await this.takeawayServices.afs.collection('orders').add(order);
    });
  }

  async createAndReturnCustomer() {
    var customer = {
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'name': this.translate.instant('general-sin-cliente'),
      'business_name': '',
      'business_number': '',
      'email': '',
      'phone': '',
      'address': '',
      'note': '',
      'created_at': new Date()
    };
    await this.takeawayServices.afs.collection('orders').add(customer).then(async doc => {
      customer['UID'] = doc.id;
    });

    return customer;
  }

  is_girona = false;
  checkGirona() {
    //Comprovamos los UID de los restaurantes para saber si es del Girona
    if (this.globals.restaurant_uid == '9LXypA7YjaMswTPfVg1g'
      || this.globals.restaurant_uid == 'KODznOlh7l9b7vblbOuR'
      || this.globals.restaurant_uid == '9Asns3zTW0T0Cc5PJgLu'
      || this.globals.restaurant_uid == 'E7CYyj30xc0PDLJ111Bj'
      || this.globals.restaurant_uid == 'nNgd4t9C63xdYZZ2Ql0H'
      || this.globals.restaurant_uid == 'TczbaMYn0zvpGpGkLvrj'
      || this.globals.restaurant_uid == 'dchoFpUJRkRgMOJCdkUK'
      || this.globals.restaurant_uid == 'eIpuaSl0PXln3EGEedpa'
      || this.globals.restaurant_uid == '8DHNvP8l5sXGBDeEbe4H'
      || this.globals.restaurant_uid == 'Z72lb9K7l4aWLtj69ID8'
      || this.globals.restaurant_uid == 'yWhJE6Gaf09bXunzFR6V') {
      this.is_girona = true;
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/ods/services.ts